<template>
  <div v-if="offerta">
    <div v-if="nomeSquadra">
      <div :class="['squadra-offerta', { small }]">

        <div class="squadra-wrapper">
          <img class="picture" :src="picSquadra" />
          <crediti
            v-if="showBadgeOfferta"
            :crediti="offerta"
            :variant="creditiStyle"
            :glow="creditiGlow"
            class="crediti-badge"
          ></crediti>
        </div>

        <div v-if="label != ''" class="text-left ml-2">
          <div class="label font-hemi-head text--text text--lighten-2">{{ label }}</div>
          <div class="nome">{{ nomeSquadra }}</div>
          <div v-if="time" class="offerta_time">
            <v-icon small left>access_time</v-icon
            ><small><span v-html="time"></span></small>
          </div>
        </div>

        <crediti
          v-if="showHorizontalOfferta"
          :crediti="offerta"
          use-icon
          :variant="creditiStyle"
          :glow="creditiGlow"
          class="crediti-horizontal"
        ></crediti>

      </div>
    </div>
  </div>
  <div v-else>
    <div v-if="ifNoOfferta != ''">
      <div>{{ ifNoOfferta }}</div>
    </div>
  </div>
</template>

<script>
import mixins from "../../js/mixins";
import Crediti from "./Crediti";

export default {
  name: "squadra-offerta",
  mixins: [mixins],
  components: {
    Crediti,
  },
  props: {
    offerta: {
      type: Number,
      required: false,
      default: null,
    },
    uid: {
      type: [Number, String],
      required: false,
      default: null,
    },
    time: {
      type: [Number, String],
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: "Migliore offerta",
    },
    ifNoOfferta: {
      type: String,
      required: false,
      default: "",
    },
    small: {
      type: Boolean,
    },
    showOfferta: {
      type: Boolean,
      default: true,
    },
    variant: {
      type: String,
      default: "",
    },
    creditiStyle: {
      type: String,
      default: "dark",
      validator: (value) => ["dark", "light"].includes(value),
    },
    creditiGlow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isHorizontal() {
      return this.variant == "horizontal";
    },
    showBadgeOfferta() {
      return this.showOfferta && !this.isHorizontal;
    },
    showHorizontalOfferta() {
      return this.showOfferta && this.isHorizontal && this.offerta > 0;
    },
    nomeSquadra() {
      try {
        return this.squadra(this.uid).name;
      } catch (error) {
        return false;
      }
    },
    picSquadra() {
      try {
        return this.squadra(this.uid).pic;
      } catch (error) {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.squadra-offerta {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
    .label{
    font-weight: 900;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .nome{
font-weight: 900;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 15px;
  }
  .squadra-wrapper {
    display: inline-block;
    border-radius: 50%;
    height: 50px;
    width: 50px;
    position: relative;
    box-shadow: 0 2px 5px rgb(0 0 0 / 8%);
    background: white;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border-radius: 50%;
      border: 3px solid white;
      position: absolute;
      top: 0;
      left: 0;
    }
    .crediti-badge {
      position: absolute;
      top: -3px;
      right: -7px;
    }
  }
  &.small {
    .squadra-wrapper {
      width: 28px;
      height: 28px;
    }

    .crediti-badge {
      top: -2px;
      right: -5px;
      font-size: 8px;
      line-height: 1;
      padding: 1px 4px;
      border-radius: 3px;
    }

    .text-left {
      font-size: 10px;
      line-height: 1.1;
    }
  }
}
</style>
